import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'secondsToTimeString',
    standalone: true
})
export class SecondsToTimeStringPipe implements PipeTransform {
    constructor(public translate: TranslateService) {

    }

    transform(value: any, args?: any): any {

        return this.msToString(value);
    }

    msToString(valSeconds) {
        const milleSeconds = valSeconds * 1000
        const lang = this.translate.currentLang;
        const s_day = (lang === 'fr') ? 'jour' : 'day';
        const s_hour = (lang === 'fr') ? 'heure' : 'hour';
        const s_minute = 'minute';
        const s_second = (lang === 'fr') ? 'seconde' : 'second';

        const seconds = Math.floor(milleSeconds / 1000);
        const days = Math.floor(seconds / 86400);
        const hours = Math.floor((seconds % 86400) / 3600);
        const minutes = Math.floor(((seconds % 86400) % 3600) / 60);
        const sds = Math.floor(((seconds % 86400) % 3600) % 60);

        let timeString = '';
        if (days > 0) {
            timeString += days + ' ' + this.plural(s_day, days) + ' ';
            timeString += hours + ' ' + this.plural(s_hour, hours);
        } else if (hours > 0) {
            timeString += hours + ' ' + this.plural(s_hour, hours) + ' ';
            timeString += minutes + ' ' + this.plural(s_minute, minutes);
        } else if (minutes > 0) {
            timeString += minutes + ' ' + this.plural(s_minute, minutes) + ' ';
            timeString += sds + ' ' + this.plural(s_second, sds);
        } else if (sds >= 0) {
            timeString += sds + ' ' + this.plural(s_second, sds);
        }
        return timeString;
    }

    plural(str, unit) {
        if (unit > 1) {
            return str + 's';
        }
        return str;
    }

}
